module.exports = __webpack_public_path__ + "img/category_35.2b36e05f.png";